<template>
    <div class="details">
        <header class="title">
            <span class="pole"></span>
            <span class="str">问题详情</span>
            <van-icon :name="show ? 'arrow-down' : 'arrow'" class="show" @click="showSurplusEvent"></van-icon>
        </header>
        <van-row type="flex" justify="space-between" class="content">
            <van-col span="8" class="caption">风险名称</van-col>
            <van-col span="16" class="lr">{{ info.riskName }}</van-col>
        </van-row>
        <van-row type="flex" justify="space-between" class="content">
            <van-col span="8" class="caption">风险编号</van-col>
            <van-col span="16" class="lr">{{ info.riskId }}</van-col>
        </van-row>
        <van-row type="flex" justify="space-between" class="content">
            <van-col span="8" class="caption">风险等级</van-col>
            <van-col span="16" class="lr">{{ info.riskLevelName }}</van-col>
        </van-row>
        <van-row type="flex" justify="space-between" class="content">
            <van-col span="8" class="caption">业务领域</van-col>
            <van-col span="16" class="lr">{{ info.businessFieldName }}</van-col>
        </van-row>
        <van-row type="flex" justify="space-between" class="content">
            <van-col span="8" class="caption">二级流程</van-col>
            <van-col span="16" class="lr">{{ info.twoLevelProcessName }}</van-col>
        </van-row>
        <van-row type="flex" justify="space-between" class="content">
            <van-col span="8" class="caption">三级流程</van-col>
            <van-col span="16" class="lr">{{ info.threeLevelProcessName }}</van-col>
        </van-row>
        <van-row type="flex" justify="space-between" class="content">
            <van-col span="8" class="caption">被审单位</van-col>
            <van-col span="16" class="lr">{{ info.auditeeOrgName }}</van-col>
        </van-row>
        <van-row type="flex" justify="space-between" class="content">
            <van-col span="8" class="caption">价值影响(万元)</van-col>
            <van-col span="16" class="lr">{{ info.valueImpact }}</van-col>
        </van-row>
        <van-row type="flex" justify="space-between" class="content">
            <van-col span="8" class="caption">发现人员</van-col>
            <van-col span="16" class="lr">{{ info.problemFindUserName }}</van-col>
        </van-row>
        <van-row type="flex" justify="space-between" class="content">
            <van-col span="8" class="caption">整改追踪人</van-col>
            <van-col span="16" class="lr">{{ info.problemTrackUserName }}</van-col>
        </van-row>
        <!-- 折叠的数据 -->
        <div v-show="show">
            <van-row type="flex" justify="space-between" class="content">
                <van-col span="8" class="caption">问题分类</van-col>
                <van-col span="16" class="lr">{{ info.problemTypeName }}</van-col>
            </van-row>
            <van-row type="flex" justify="space-between" class="content">
                <van-col span="8" class="caption">问题所属期间</van-col>
                <van-col span="16" class="lr">{{ info.dateArea }}</van-col>
            </van-row>
            <ul class="content">
                <li class="caption" style="margin-bottom: 7px;">标准依据</li>
                <li>
                    {{ getProblemAccording }}
                    <span style="color: #999;" v-if="info.problemAccording.length > 60" @click="expandHideEvent('problemAccording')">{{ visible.problemAccording ? " 收起" : "...展开" }}</span>
                </li>
            </ul>
            <ul class="content">
                <li class="caption" style="margin-bottom: 7px;">问题描述</li>
                <li>
                    {{ getProblemDesc }}
                    <span style="color: #999;" v-if="info.problemDesc.length > 60" @click="expandHideEvent('problemDesc')">{{ visible.problemDesc ? " 收起" : "...展开" }}</span>
                </li>
            </ul>
            <van-row type="flex" justify="space-between" class="content">
                <van-col span="8" class="caption">影响类型</van-col>
                <van-col span="16" class="lr">{{ info.problemAffectTypeName }}</van-col>
            </van-row>
            <ul class="content">
                <li class="caption" style="margin-bottom: 7px;">影响分析</li>
                <li>
                    {{ getProblemAffect }}
                    <span style="color: #999;" v-if="info.problemAffect.length > 60" @click="expandHideEvent('problemAffect')">{{ visible.problemAffect ? " 收起" : "...展开" }}</span>
                </li>
            </ul>
            <ul class="content">
                <li class="caption" style="margin-bottom: 7px;">问题原因</li>
                <li v-for="(item,index) in visible.problemCauseList" :key="index">
                    <span v-if="visible.problemCauseList.length > 1">{{ (index + 1) + '.' }}</span>
                    {{ getCauseContent(index) }}
                    <span style="color: #999;" v-if="item.causeContent.length > 60" @click="expandHideListEvent(index,'problemCauseList')">{{ item.visible ? " 收起" : "...展开" }}</span>
                </li>
            </ul>
            <van-row type="flex" justify="space-between" class="content">
                <van-col span="8" class="caption">是否认可</van-col>
                <van-col span="16" class="lr">{{ info.feedbackStatusName }}</van-col>
            </van-row>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        info: {
            type: Object,
            require: true
        }
    },
    data(){
        return {
            show: false,
            visible: {
                problemDesc: false,
                problemAffect: false,
                problemCauseList: [],
                problemAccording: false
            }
        }
    },
    methods: {
        showSurplusEvent(){
            this.show = !this.show;
        },
        expandHideEvent(name){
            this.visible[name] = !this.visible[name];
        },
        expandHideListEvent(index,name){
            let info = this.visible[name].find((item,i) => i == index);
            info.visible = !info.visible;
            this.$set(this.visible[name],index,info);
        },
        getCauseContent(index){
            return this.visible.problemCauseList[index].visible ? this.visible.problemCauseList[index].causeContent : this.visible.problemCauseList[index].causeContent.slice(0,60);
        }
    },
    computed: {
        getProblemDesc(){
            return this.visible.problemDesc ? this.info.problemDesc : this.info.problemDesc.slice(0,60);
        },
        getProblemAffect(){
            return this.visible.problemAffect ? this.info.problemAffect : this.info.problemAffect.slice(0,60);
        },
        getProblemAccording(){
            return this.visible.problemAccording ? this.info.problemAccording : this.info.problemAccording.slice(0,60);
        }
    },
    watch: {
        "info.problemCauseList":{
            deep: true,
            immediate: true,
            handler(newValue,oldValue){
                this.visible.problemCauseList = this.info.problemCauseList.map(item => {
                    return {...item,visible: false}
                })
            }   
        }
    }
}
</script>
<style lang="less" scoped>
    //主标题字号
    @titleSize: 16px;
    //主标题颜色
    @titleColor: #0ea6e0;
    //中等字号
    @middleSize: 14px;
    //主体小字字号
    @contentSize: 12px;
    //内容小字颜色
    @contentColor: #7f7f7f;

    //板块radius
    @borderRadius: 4px;

    //边框阴影
    @boxShadow: 2px 2px 5px 0 rgba(0, 0, 0, 0.2);

    //预览标题颜色
    @previewColor: #000;
    .details{
        background-color: #fff;
        border-radius: @borderRadius;
        box-shadow: @boxShadow;
        overflow: hidden;
        margin-top: 15px;
        padding-bottom: 10px;
        text-align: left;
        font-size: @contentSize;
        .title{
            margin: 20px 15px 0 15px;
            text-align: left;
            overflow: hidden;
            position: relative;
            .pole{
                color: @titleColor;
                font-size: @titleSize;
                border-left: 3px solid #0ea6e0;
            }
            .str,.str_border_null{
                width: 100%;
                font-size: @middleSize;
                display: inline-block;
                margin-left: 5px;
                font-weight: bold;
                padding-bottom: 5px;
                border-bottom: 1px solid #d7d7d7;
            }
            .str_border_null{
                border: unset;
                width: 80%;
                margin-bottom: 5px;
            }
            .icon{
                float: right;
                font-size: 16px;
                font-weight: bold;
            }
            
            .show{
                position: absolute;
                right: 0;
                top: 4px;
            }
        }
        .content{
            margin: 10px 15px 5px 23px;
            padding-bottom: 3px;
            border-bottom: 1px solid #f3f3f3;
            .caption{
                color: @contentColor;
                img{
                    border: 1px solid #000 !important;
                    border-radius: @borderRadius !important;
                }
            }
            .lr{
                text-align: right;
                position: relative;
                span{
                    position: absolute;
                    right: 0;
                    top: 0;
                    display: inline-block;
                    // border: 1px solid rgba(121, 121, 121, 1);
                }
            }
        }
        .content:last-child{
            border: unset;
        }
    }
</style>